import { STORE_KEY } from './slice';

const selectVendorState = state => state[STORE_KEY] || {};

export const selectVendorData = state => {
  const data = selectVendorState(state).data || [];
  return data;
};

export const selectVendorLoading = state => selectVendorState(state).loading;
export const selectVendorError = state => selectVendorState(state).error;
export const selectVendorFilters = state => selectVendorState(state).filters || {};
export const selectVendorSearchTerm = state => selectVendorState(state).searchTerm || '';
export const selectVendorFilterVisible = state => selectVendorState(state).filterVisible || false;
export const selectTileView = state => selectVendorState(state).showTileView || true;

export const selectFilteredVendors = state => {
  const data = selectVendorData(state);
  const searchTerm = selectVendorSearchTerm(state);
  const filters = selectVendorFilters(state);

  if (!data || data.length === 0) {
    return [];
  }

  const filtered = data.filter(vendor => {
    // Search filter
    const matchesSearch = !searchTerm || 
      (vendor.vendorName && vendor.vendorName.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (vendor.location && vendor.location.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (vendor.contactPerson && vendor.contactPerson.toLowerCase().includes(searchTerm.toLowerCase()));

    // Status filter
    const matchesStatus = !filters.status?.value || 
      (vendor.status && vendor.status.toLowerCase() === filters.status.value.toLowerCase());

    // Vendor filter
    const matchesVendor = !filters.vendor?.value || 
      vendor.id === filters.vendor.value;

    return matchesSearch && matchesStatus && matchesVendor;
  });

  return filtered;
};

export const selectfetchVendorLoading = state => selectVendorLoading(state); 